import { loadComponent } from '@/helpers/asyncLoaders'
import store from '@/store/store'

import {
  VUEX_USER_HAS_CONFERENCE_ASIAN,
  VUEX_USER_HAS_CONFERENCE_DOMESTIC,
  VUEX_USER_HAS_CONFERENCE_INTERNATIONAL
} from '@/store/constants/user'

const hasPerms = () => {
  return store.getters[VUEX_USER_HAS_CONFERENCE_ASIAN] ||
    store.getters[VUEX_USER_HAS_CONFERENCE_DOMESTIC] ||
    store.getters[VUEX_USER_HAS_CONFERENCE_INTERNATIONAL]
}

export const routes = {
  path: 'fall26',
  name: 'fall26--main',
  meta: {
    conferenceClass: 'fall25'
  },
  component: loadComponent('GlobalConference/Fall26/Main.vue'),
  redirect: { name: 'fall26--landing' },
  children: [
    {
      path: 'load',
      name: 'fall26--load',
      component: loadComponent('GlobalConference/Fall26/Pages/Load.vue')
    },
    {
      path: 'landing',
      name: 'fall26--landing',
      component: loadComponent('GlobalConference/Fall26/Pages/Landing.vue'),
      beforeEnter: (to, from, next) => {
        if (!store.state.globalConference.fall25.loaded) {
          return next({ name: 'fall26--load' })
        }
        next()
      }
    },
    {
      path: 'categories',
      name: 'fall26--categories',
      component: loadComponent('GlobalConference/Fall26/Pages/Categories.vue'),
      meta: {
        eventCategory: 'fall26',
        title: 'Product Categories',
        navigation: [
          'Womens',
          'Mens',
          'Kids',
          'Unisex'
        ]
      }
    },
    {
      path: '',
      name: 'fall26--dashboard',
      component: loadComponent('GlobalConference/Fall26/Dashboard.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPerms()) {
          next()
        } else {
          next('/')
        }
      },
      children: [
        {
          path: '',
          name: 'fall26--dashboard-default',
          redirect: { name: 'fall26--ads' }
        },
        {
          path: 'ads',
          name: 'fall26--ads',
          component: loadComponent('GlobalConference/Fall26/Pages/Advertising.vue'),
          meta: {
            eventCategory: 'fall26',
            title: 'Advertising',
            navigation: [
              'Marketing',
              'Womens',
              'Mens',
              'Kids',
              'Unisex',
              'Work',
              'BTS',
              'International',
              'Performance',
              'Social',
              'Radio',
              'Apparel'
            ]
          }
        },
        {
          path: 'sessions',
          name: 'fall26--sessions',
          component: loadComponent('GlobalConference/Fall26/Pages/Sessions.vue'),
          meta: {
            eventCategory: 'fall26',
            title: 'General Sessions'
          }
        }
      ]
    }
  ]
}

/* export const routes = {
  path: 'fall25',
  name: 'fall26--main',
  meta: {
    conferenceClass: 'fall25'
  },
  component: loadComponent('GlobalConference/Fall26/Main.vue'),
  redirect: { name: 'fall26--dashboard' },
  children: [
    {
      path: 'dashboard',
      name: 'fall26--dashboard',
      component: loadComponent('GlobalConference/Fall26/Dashboard.vue'),
    },

    {
      path: 'categories',
      name: 'fall26--categories',
      component: loadComponent('GlobalConference/Fall26/Pages/Categories.vue'),
      meta: {
        eventCategory: 'fall26',
        title: 'Product Categories',
        navigation: [
          'Womens',
          'Mens',
          'Kids',
          'Unisex'
        ]
      }
    },
  ]
} */
